import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=2f202f94"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports